import { render, staticRenderFns } from "./TopChoiceSection.vue?vue&type=template&id=d827e360&scoped=true&"
import script from "./TopChoiceSection.vue?vue&type=script&lang=js&"
export * from "./TopChoiceSection.vue?vue&type=script&lang=js&"
import style0 from "./TopChoiceSection.vue?vue&type=style&index=0&id=d827e360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827e360",
  null
  
)

export default component.exports